import React, { PureComponent } from "react";

import {
  Line,
  Bar,
  XAxis,
  Tooltip,
  BarChart,
  ResponsiveContainer,
  LineChart,
  LabelList,
} from "recharts";
// import { render } from "@testing-library/react";
// import { toggleDataConstruct } from "./util-function";
import {valueConverter} from '../../util-functions/util-funtions'

const COLOR = ["#4472c4", "#ed7708"];

class CustomizedAxisTick extends PureComponent {
  render() {
    const { x, y, payload } = this.props;

    return (
      <g
        className="abc"
        style={{ fontFamily: "SourceSansPro", fontSize: 13 }}
        transform={`translate(${x},${y})`}
      >
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="end"
          fill="#666"
          transform="rotate(-35)"
        >
          {`W${payload.value}`}
        </text>
      </g>
    );
  }
}

// const data = [
//   {
//     Weekno: 1,
//     SecondarySale: "34.000",
//     EndStock: "87.000",
//   },
//   {
//     Weekno: 2,
//     SecondarySale: "21.000",
//     EndStock: "51.000",
//   },
//   {
//     Weekno: 3,
//     SecondarySale: "67.000",
//     EndStock: "45.000",
//   },
//   {
//     Weekno: 4,
//     SecondarySale: "98.000",
//     EndStock: "76.000",
//   },
//   {
//     Weekno: 5,
//     SecondarySale: "98.000",
//     EndStock: "45.000",
//   },
//   {
//     Weekno: 6,
//     SecondarySale: "67.000",
//     EndStock: "45.000",
//   },
//   {
//     Weekno: 7,
//     SecondarySale: "87.000",
//     EndStock: "56.000",
//   },
//   {
//     Weekno: 8,
//     SecondarySale: "76.000",
//     EndStock: "45.000",
//   },
//   {
//     Weekno: 9,
//     SecondarySale: "87.000",
//     EndStock: "65.000",
//   },
//   {
//     Weekno: 10,
//     SecondarySale: "56.000",
//     EndStock: "34.000",
//   },
//   {
//     Weekno: 11,
//     SecondarySale: "34.000",
//     EndStock: "67.000",
//   },
//   {
//     Weekno: 12,
//     SecondarySale: "45.000",
//     EndStock: "67.000",
//   },
//   {
//     Weekno: 13,
//     SecondarySale: "45.000",
//     EndStock: "76.000",
//   },

//   {
//     Weekno: 14,
//     SecondarySale: "56.000",
//     EndStock: "78.000",
//   },
//   {
//     Weekno: 15,
//     SecondarySale: "23.000",
//     EndStock: "89.000",
//   },
//   {
//     Weekno: 16,
//     SecondarySale: "56.000",
//     EndStock: "23.000",
//   },
//   {
//     Weekno: 17,
//     SecondarySale: "45.000",
//     EndStock: "23.000",
//   },
//   {
//     Weekno: 18,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 19,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 20,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 21,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 22,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 18,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 23,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 24,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 25,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 26,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 27,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 28,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 29,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 30,
//     SecondarySale: "09.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 32,
//     SecondarySale: "98.000",
//     EndStock: "77.000",
//   },
//   {
//     Weekno: 32,
//     SecondarySale: "78.000",
//     EndStock: "34.000",
//   },
//   {
//     Weekno: 33,
//     SecondarySale: "51.000",
//     EndStock: "34.000",
//   },
//   {
//     Weekno: 34,
//     SecondarySale: "23.000",
//     EndStock: "43.000",
//   },
//   {
//     Weekno: 35,
//     SecondarySale: "78.000",
//     EndStock: "67.000",
//   },
//   {
//     Weekno: 36,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 37,
//     SecondarySale: "09.000",
//     EndStock: "34.000",
//   },
//   {
//     Weekno: 38,
//     SecondarySale: "78.000",
//     EndStock: "98.000",
//   },

//   {
//     Weekno: 39,
//     SecondarySale: "76.000",
//     EndStock: "98.000",
//   },
//   {
//     Weekno: 40,
//     SecondarySale: "45.000",
//     EndStock: "55.000",
//   },
//   {
//     Weekno: 41,
//     SecondarySale: "89.000",
//     EndStock: "78.000",
//   },
//   {
//     Weekno: 42,
//     SecondarySale: "45.000",
//     EndStock: "34.000",
//   },
//   {
//     Weekno: 43,
//     SecondarySale: "51.000",
//     EndStock: "45.000",
//   },
//   {
//     Weekno: 44,
//     SecondarySale: "44.000",
//     EndStock: "88.000",
//   },
//   {
//     Weekno: 45,
//     SecondarySale: "23.000",
//     EndStock: "45.000",
//   },
//   {
//     Weekno: 46,
//     SecondarySale: "85.000",
//     EndStock: "34.000",
//   },
//   {
//     Weekno: 47,
//     SecondarySale: "56.000",
//     EndStock: "34.000",
//   },
//   {
//     Weekno: 48,
//     SecondarySale: "78.000",
//     EndStock: "23.000",
//   },
//   {
//     Weekno: 49,
//     SecondarySale: "51.000",
//     EndStock: "56.000",
//   },
//   {
//     Weekno: 50,
//     SecondarySale: "51.000",
//     EndStock: "54.000",
//   },
//   {
//     Weekno: 51,
//     SecondarySale: "51.000",
//     EndStock: "21.000",
//   },
//   {
//     Weekno: 52,
//     SecondarySale: "51.000",
//     EndStock: "23.000",
//   },
// ];
const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props;

  // return <text x={x-2} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="start" verticalAnchor='start'>{Number.parseInt(value).toLocaleString()}</text>
  return <text x={x-2} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="start" verticalAnchor='start'>{valueConverter(value)}</text>


}

export class SecondarySalesEndStockChar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataSet: [
        { name: "SecondarySale", flag: true },
        { name: "Endstock", flag: true },
      ],
    };
  }
  // static getDerivedStateFromProps(props, state) {
  //   if (state.dataSet.length == 0) {
  //     console.log(props);
  //     // let result = toggleDataConstruct(props.data ? props.data : data);
  //     console.log(result);
  //   }
  // }

  toggleKey(indx) {
    let { dataSet } = this.state;
    dataSet[indx].flag = !dataSet[indx].flag;
    this.setState({ dataSet });
  }

  
  render() {
    // for (let a = 0; a < 52; a++) {
    //   data.push({
    //     Weekno: `W${a + 1}`,
    //     SecondarySale: Math.floor(Math.random() * 10000),
    //     EndStock: Math.floor(Math.random() * 10000),
    //   });
    // }
    // console.log(this.props.data);
    let { dataSet } = this.state;
    // console.log(this.props);
    return (
      <div className="">
        <ResponsiveContainer width="100%" height={200}>
          <LineChart
            width={200}
            height={300}
            // data={this.props.data.length > 0 ? this.props.data : data}
            data={this.props.endStock}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <Tooltip
              formatter={function (value, name) {
                return `${Number(value.toFixed(0)).toLocaleString()}`;
              }}
              labelFormatter={function (value) {
                return `WeekNo: ${value + 1}`;
              }}
            />
           
            <Line
              // dataKey="SecondarySale"
              dataKey={`${
                dataSet.length > 0 && dataSet[1].flag ? dataSet[1].name : ""
              }`}
              fill="#ed7708"
              // radius={[5, 5, 0, 0]}
              // width={20}
              strokeWidth={2}
              type="monotone"
              stroke="#ed7708"
              dot={false}
              // barSize={25}
              // dot={{ stroke: "#ed7708", strokeWidth: 2 }}
            >
               <LabelList content={<CustomizedLabel myProps={dataSet?dataSet[0]:[]} />} position="insideTop" />
            </Line>
          </LineChart>
        </ResponsiveContainer>
        <ResponsiveContainer width="100%" height={210}>
          <BarChart
            data={this.props.secondarySale}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            {/* <YAxis/> */}
            {/* <CartesianGrid strokeDasharray="3 3" /> */}
            <XAxis dataKey="WeekNo" tick={<CustomizedAxisTick />} height={40} />
            <Tooltip
              formatter={function (value, name) {
                return `${Number(value.toFixed(0)).toLocaleString()}`;
              }}
              labelFormatter={function (value) {
                return `WeekNo: ${value}`;
              }}
            />
            <Bar
              // dataKey="Endstock"
              dataKey={`${
                dataSet.length > 0 && dataSet[0].flag ? dataSet[0].name : ""
              }`}
              fill="#4472c4"
              label={<CustomizedLabel myProps={dataSet?dataSet[0]:[]} />}
              // radius={[5, 5, 0, 0]}
              width={20}
              barSize={15}
            >
              {/* <LabelList
                dataKey={`${
                  dataSet.length > 0 && dataSet[1].flag ? dataSet[1].name : ""
                }`}
                position="top"
              /> */}
            </Bar>
          </BarChart>
        </ResponsiveContainer>

        {/* <ResponsiveContainer>
          <ComposedChart
            data={this.props.data ? this.props.data : data}
            margin={{
              top: 20,
              right: 20,
              bottom: 20,
              left: 20,
            }}
          >
            <XAxis dataKey="Weekno" />
            <Tooltip />
            <Line
              dataKey={`${
                dataSet.length > 0 && dataSet[1].flag ? dataSet[1].name : ""
              }`}
              stroke="#82ca9d"
              width={30}
              strokeWidth={2}
              dot={false}
            />
          </ComposedChart>
        </ResponsiveContainer>
         */}
        {dataSet ? (
          <ul className="ul-ES">
            {this.state.dataSet.map((itm, ind) => {
              return (
                <li
                  className="SS-ES-li"
                  onClick={() => this.toggleKey(ind)}
                  style={
                    itm.flag
                      ? { textDecoration: "", color: COLOR[ind] }
                      : { textDecoration: "line-through", color: COLOR[ind] }
                  }
                >
                  <div
                    style={{
                      height: 10,
                      width: 10,
                      backgroundColor: COLOR[ind],
                      float: "left",
                      margin: 7,
                    }}
                  ></div>
                  {itm.name}
                </li>
              );
            })}
          </ul>
        ) : (
          ""
        )}
      </div>
    );
  }
}
